import { images } from "../constants";

const gallery = [
    images.galleryPartners1,
    images.galleryPartners2,
    images.galleryPartners3,
    images.galleryPartners4,
    images.galleryPartners5,
    images.galleryPartners6,
];

export default gallery;